import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { desktop } from 'styles/media';
import * as zIndex from 'styles/zIndex';

const { color, radius } = theme;

const wrap: CSSObject = {
  position: 'relative',
  zIndex: zIndex.HEADER,
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  height: '56px',
  padding: '0 8px 0 4px',
  background: color.white,
  boxShadow: `inset 0 -1px 0 ${color.grey75}`,
  [desktop]: {
    display: 'none',
  },
};

const menuButton: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 44,
  height: 44,
  borderRadius: radius.md,
  color: color.text,
  ':active': {
    background: color.grey75,
  },
};

const logos: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  height: 44,
  '> img': {
    height: 22,
    width: 'auto',
  },
};

export { wrap, menuButton, logos };
